import angular from 'angular';
import tradePersonalReferencesSection from './tradePersonalReferencesSection';
import './style.scss';

export default angular
  .module('scenes.loanAppSections.scenes.tradePersonalReferencesSection', [])
  .component('tradePersonalReferencesSection', tradePersonalReferencesSection)
  .name;
